import React from "react";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

const ImagePopup = ({ isOpen, imageUrl, closeModal }) => {
  const modalStyle = {
    position: "fixed", // Posisi tetap di seluruh layar
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0, // Menghapus margin
    padding: 0, // Menghapus padding
    zIndex: 1050, // Agar modal berada di atas semua konten lain
    background: "rgba(0, 0, 0, 0.8)", // Background transparan gelap
  };

  const modalContentStyle = {
    border: "none",
    height: "100%", // Modal mengambil seluruh tinggi layar
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: 0, // Menghapus padding
  };

  const imgStyle = {
    width: "auto",
    height: "90vh",
    maxWidth: "70vw",
    objectFit: "contain", // Gambar tetap di dalam kontainer tanpa terpotong
  };

  const closeBtnStyle = {
    position: "absolute",
    top: "-40px", // Tombol close 10px dari atas
    right: 0, // Tombol close 10px dari kanan
    fontSize: "2rem", // Ukuran font tombol "X"
    background: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
    zIndex: 1060, // Pastikan tombol close berada di atas gambar
    padding: 0,
    margin: 0,
  };

  return (
    <Modal className="modal-image" show={isOpen} onHide={closeModal} fullscreen>
      <Modal.Body className="d-flex justify-content-center align-items-center p-0">
        <img
          src={imageUrl}
          alt="Popup"
          style={{
            width: "auto",
            height: "70%",
            maxWidth: "auto",
            objectFit: "contain",
          }}
        />
        <button
          className="position-absolute top-0 end-0 m-3 p-0 btn bg-none"
          onClick={closeModal}
        >
          <FaTimes className="text-white" size={24} />
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ImagePopup;
